import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from '@okapi/helmet-react';
import { selectPageModelSE0 } from 'store/pageModel';
import { selectTopCategories } from 'containers/catalogue/catalogue/selectors';
import { selectServices } from 'containers/instore/instore-service/selectors';
import { selectConfigurators, selectRating } from 'containers/configurators-listing/selectors';
import { getAggregateRating, getOfferData, isInstorePage } from './utils';
import { SELLER_DATA } from './constants';

export const SEOProductSchema = () => {
	const pageModelSEO = useSelector(selectPageModelSE0);
	const categories = useSelector(selectTopCategories);
	const services = useSelector(selectServices);
	const configurators = useSelector(selectConfigurators);
	const rating = useSelector(selectRating);

	const name = pageModelSEO?.h1 || '';
	const productName = services.length ? name.split(' в ')[0] : name;
	const description = pageModelSEO?.metadescription || '';
	const canonicalUrl = pageModelSEO?.canonicalURL || '';

	const catalogueOfferData = getOfferData(categories, 'categories'); // для УиР
	const instoreOfferData = getOfferData(services, 'services'); // для инсторов
	const slpOfferData = getOfferData(configurators, 'configurators'); // для SLP

	const offerData = catalogueOfferData || instoreOfferData || slpOfferData || null;
	const offers = offerData
		? {
				offers: {
					'@type': 'AggregateOffer',
					availability: 'https://schema.org/InStock',
					url: canonicalUrl,
					priceCurrency: 'RUB',
					...offerData,
					...SELLER_DATA,
				},
		  }
		: {};

	const isInstore = isInstorePage(canonicalUrl);
	const ratingData = isInstore || rating.length ? getAggregateRating(rating) : null;
	const aggregateRating = ratingData
		? {
				aggregateRating: {
					'@type': 'AggregateRating',
					bestRating: '5',
					worstRating: '1',
					...ratingData,
				},
		  }
		: {};

	const jsonLdData = {
		'@context': 'https://schema.org',
		'@type': 'Product',
		name: productName,
		image: 'https://cdn.lemanapro.ru/lmru/image/upload/other/logo/logo.svg',
		description,
		...offers,
		...aggregateRating,
	};

	return (
		<Helmet>
			<script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
		</Helmet>
	);
};
